import React from "react";
import {materialUnitLabel} from "./rsoMaterialForecastHelpers";

const quantityText = (value) => typeof value === "number" && Number.isFinite(value)
  ? new Intl.NumberFormat(undefined,{maximumFractionDigits:4}).format(value) : null;
const priceUnitLabel = (value) => ({SF:"square foot",SY:"square yard",EA:"item",LF:"linear foot",BOX:"box",ROLL:"roll",YD:"yard"}[value.trim().toUpperCase()] || value.trim());
const priceText = (value, currency) => {
  if (typeof value !== "number" || !Number.isFinite(value) || value < 0) return null;
  const code = typeof currency === "string" && /^[A-Z]{3}$/.test(currency) ? currency : null;
  return `${new Intl.NumberFormat(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}).format(value)} ${code || "(currency unavailable)"}`;
};

const RsoCurrentMaterial = ({sourceProductId, property, stock}) => {
  // Always use the current property setup, never the forecast's replacement.
  const source = (property.layouts || []).flatMap((layout) => layout.materials || [])
    .find((material) => Number(material.productId) === Number(sourceProductId));
  const name = source?.privateName || [source?.manufacturer, source?.style, source?.color].filter(Boolean).join(" ")
    || "Material name unavailable";
  const item = source && stock?.status === "ready" ? stock.items.find((item) => item.productId === Number(sourceProductId)) : null;
  const pending = stock?.status === "loading";
  const missing = pending ? "Checking…" : "Not available";
  const quantity = quantityText(item?.quantityOnHand);
  const uom = typeof item?.uom === "string" && item.uom.trim() ? materialUnitLabel(item.uom) || item.uom : null;
  const priceUom = typeof item?.priceUom === "string" && item.priceUom.trim() ? priceUnitLabel(item.priceUom) : null;
  const scope = item?.stockScope === "all_locations" ? "All locations" : item?.stockScope === "warehouse" && typeof item?.warehouse === "string" && item.warehouse.trim()
    ? item.warehouse.trim() : null;
  const asOf = stock?.asOfUtc && !Number.isNaN(new Date(stock.asOfUtc).getTime()) ? new Date(stock.asOfUtc).toLocaleString() : null;
  return <section className="rsf-current-material" aria-label={`Current material for ${name}`}>
    <div className="rsf-current-material-name"><span>Using now</span><strong>{name}</strong></div>
    {stock && <>
      <div><span>Stock left</span><strong>{quantity !== null && uom && scope ? `${quantity} ${uom}` : missing}</strong>
        {scope && <small>{scope}</small>}</div>
      <div><span>{priceUom ? `Suggested sale price per ${priceUom}` : "Suggested sale price per unit"}</span>
        <strong>{priceUom ? priceText(item?.suggestedSalePrice,item?.currencyCode) || missing : missing}</strong></div>
      {item && <details className="rsf-stock-details"><summary>Stock details</summary>
        {scope && <p>{item.stockScope === "all_locations" ? "Stock is shared across all locations, not reserved for this property." : `Stock shown for ${scope}, not reserved for this property.`}</p>}
        {asOf && <p>Checked {asOf}.</p>}
      </details>}
    </>}
  </section>;
};

export default RsoCurrentMaterial;
